import React from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { chooseClipart } from "../../../../actions";
import ClipartCollection from "./ClipartCollection";
import "./Search.css";
import Tabs from "../../../Layout/Tabs";
import Tab from "../../../Layout/Tabs/Tab";

class Search extends React.Component {
  handleChooseClipart = (payload) => {

    //Add clipart limits to payload (possibly passing more data than needed here)
    let designId = this.props.design.product_type_id
    payload.limits = this.props.clipartLimits[designId];

    this.props.chooseClipart(payload)
    this.props.onShowDialog()
  }

  render() {
    const design = this.props.design,
      layers = design.layer_set,
      cliparts = this.props.clipart,
      categories = this.props.clipartCategories;

    let keywordsArray = [];

    // Filter layers that allow images
    const layersWithImages = layers.filter((obj) => {
      return obj.allow_image;
    });

    // Create an array of the clipart categories
    const clipartCategories = Object.values(categories),
      clipartsArray = Object.values(cliparts);

    // Alphabetise clipart categories
    clipartCategories.sort((a, b) => {
      return +(a.name > b.name) || +(a.name === b.name) - 1;
    });

    clipartsArray.map((clipart) => {
      return clipart.keywords.map((keyword) => {
        return keywordsArray.push(keyword);
      });
    });

    // Array of keyword options
    const keywordsList = keywordsArray.map((keyword) => {
      return {
        value: keyword,
        label: keyword,
        type: "keyword",
      };
    });

    // Array of category options
    const categoriesList = clipartCategories.map((category) => {
      return {
        value: category.id,
        label: category.name,
        featured: category.featured,
        type: "category",
        userId: category.userId,
      };
    });

    // Number of image layers
    const layersWithImagesCount = layersWithImages.length,
      tabsNavArray = [];

    const layerClipartList = layersWithImages.map((layer, index) => {
      tabsNavArray.push({
        name: layer.image_collection_name,
        layer_id: layer.layer_id,
      });

      if (layersWithImagesCount > 1) {
        return (
          <Tab key={layer.layer_id} id={index}>
            <ClipartCollection
              key={layer.layer_id}
              layerId={layer.layer_id}
              categoriesList={categoriesList}
              keywordsList={keywordsList}
              cliparts={clipartsArray}
              onChooseClipart={this.handleChooseClipart}
              defaultImageSize={this.props.defaultImageSize}
              user={this.props.user}
              numImageElements={layer.image_elements.length}
            />
          </Tab>
        );
      } else {
        return (
          <ClipartCollection
            key={layer.layer_id}
            layerId={layer.layer_id}
            categoriesList={categoriesList}
            keywordsList={keywordsList}
            cliparts={clipartsArray}
            onChooseClipart={this.handleChooseClipart}
            defaultImageSize={this.props.defaultImageSize}
            user={this.props.user}
            numImageElements={layer.image_elements.length}
          />
        );
      }
    });

    let layerImagesWrapper = (
      <div className="clipart--single-layer">{layerClipartList}</div>
    );

    if (layersWithImagesCount > 1) {
      // Wrap in Tabs component if more than 1 layer supports text
      layerImagesWrapper = (
        <Tabs tabsNavArray={tabsNavArray}>{layerClipartList}</Tabs>
      );
    }

    return (
      <div className="tool tool--search search-container">
        {layerImagesWrapper}
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    clipartLimits: state.clipart.limits,
    clipartCategories: state.clipart.categories,
    clipart: state.clipart.clipart,
    design: state.design.present,
    defaultImageSize: state.productOption.entity
      ? state.productOption.entity.default_image_size
      : "medium",
    user: state.user,
  };
}

function mapDispatchToProps(dispatch) {
  // Pass result of selectToolCollection to reducers
  return bindActionCreators({ chooseClipart: chooseClipart }, dispatch);
}
export default connect(mapStateToProps, mapDispatchToProps)(Search);
